import { ProductRatingService } from './../../../../../providers/services/product-rating.service';
import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { ProductService } from '../../../../../providers/services/product.service';
import { CartService } from '../../../../../providers/services/cart.service';
import { WishilistService } from '../../../../../providers/services/wishilist.service';
import { AbstractProductItem } from '../abstract-product-item';
import { MatDialog } from '@angular/material/dialog';
import { NgIf, NgFor, LowerCasePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { BarRatingModule } from 'ngx-bar-rating';
import { ThemeStorageService } from '../../../../../providers/services/theme-storage.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'pdp-product-box',
    templateUrl: './product-box-two.component.html',
    styleUrls: ['./product-box-two.component.scss'],
    imports: [NgIf, RouterLink, BarRatingModule, NgFor, LowerCasePipe, DecimalPipe, CurrencyPipe]
})
export class ProductBoxTwoComponent extends AbstractProductItem implements OnDestroy {
  public isMiloTheme: boolean = false;
  private unsubscribeThem: Subject<void> = new Subject();

  constructor(public router: Router,
              public activatedRoute: ActivatedRoute,
              public productsService: ProductService,
              public wishlistService: WishilistService,
              public cartService: CartService,
              public dialog: MatDialog,
              public ratingService: ProductRatingService,
              private themeStorageService: ThemeStorageService) {
     super(router, activatedRoute, productsService, wishlistService, cartService, dialog, ratingService);
     this.themeStorageService.getStoredThemeName().pipe(takeUntil(this.unsubscribeThem)).subscribe(theme => {
       this.isMiloTheme = theme?.name === 'milo-theme';
     });
  }

  override ngOnDestroy() {
    this.unsubscribeThem.next();
    this.unsubscribeThem.complete();
    super.ngOnDestroy();
  }
}
